import React from 'react';
const NotFound = () => {
    return (  
        <div className="content">
            <img src="https://c.tenor.com/OyUVgQi-l-QAAAAC/404.gif" alt="" style={{objectFit:"contain",}} />
        </div>
    );
}
 
export default NotFound;